<template>
    <div class="grado-form">
        <template>
            <div class="text-xs-center">
                <v-dialog v-model="showForm" width="750" scrollable>
                    <v-card>
                        <v-toolbar card prominent color="primary" dark dense>
                            <v-toolbar-title class="body-2">{{ this.formTitle }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="cancelForm()">
                                <v-icon medium>fa fa-close</v-icon>
                            </v-btn>
                            <template slot="extension">
                                <v-tabs color="primary darken-1" dark grow slider-color="yellow" v-model="activeTab">
                                    <v-tab :key="1" :href="`#tab-1`">
                                        Generales
                                    </v-tab>
                                    <v-tab :key="2" :href="`#tab-2`">
                                        Trabajo
                                    </v-tab>
                                    <v-tab :key="3" :href="`#tab-3`">
                                        Localización
                                    </v-tab>
                                </v-tabs>
                            </template>
                        </v-toolbar>

                        <v-flex>
                            <div slot="widget-content">
                                <v-alert
                                    v-model="showErrorAlert"
                                    type="error"
                                    dismissible
                                    transition="scale-transition"
                                    dark
                                >
                                    Existen errores de validación, revise los datos e intente nuevamente
                                </v-alert>
                                <v-alert
                                    v-model="showErrorDataLoadedAlert"
                                    type="error"
                                    dismissible
                                    transition="scale-transition"
                                    dark
                                >
                                    No se han podido cargar todos los datos necesarios para este formulario, intente
                                    cargar el formulario nuevamente.
                                </v-alert>
                            </div>
                        </v-flex>
                        <v-card-text>
                            <v-form ref="tutorForm" v-model="validTutor">
                                <v-tabs-items v-model="activeTab">
                                    <v-tab-item :key="1" :value="`tab-1`">
                                        <v-container fluid grid-list-xl>
                                            <v-layout align-center wrap>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="tutorItem.cedula"
                                                        label="Cédula*"
                                                        :counter="20"
                                                        :rules="cedulaFieldRules"
                                                        :error-messages="cedulaFieldErrors"
                                                        @blur="cedulaFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="tutorItem.nombre"
                                                        label="Nombre*"
                                                        :counter="255"
                                                        :rules="nombreFieldRules"
                                                        :error-messages="nombreFieldErrors"
                                                        @blur="nombreFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="tutorItem.apellido_paterno"
                                                        label="Apellido paterno*"
                                                        :counter="255"
                                                        :rules="apellido_paternoFieldRules"
                                                        :error-messages="apellido_paternoFieldErrors"
                                                        @blur="apellido_paternoFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="tutorItem.apellido_materno"
                                                        label="Apellido materno*"
                                                        :counter="255"
                                                        :rules="apellido_maternoFieldRules"
                                                        :error-messages="apellido_maternoFieldErrors"
                                                        @blur="apellido_maternoFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-menu
                                                        ref="menuFechaNacido"
                                                        v-model="menuFechaNacido"
                                                        :close-on-content-click="false"
                                                        :nudge-right="40"
                                                        lazy
                                                        transition="scale-transition"
                                                        offset-y
                                                        full-width
                                                        min-width="290px"
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field
                                                                v-model="computedFechaNacidoFormatted"
                                                                label="Fecha de nacimiento*"
                                                                v-on="on"
                                                                readonly
                                                                :rules="fecha_nacidoFieldRules"
                                                                :error-messages="fecha_nacidoFieldErrors"
                                                                @blur="
                                                                    dateFecha_nacido = parseDate(tutorItem.fecha_nacido)
                                                                "
                                                            >
                                                            </v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            v-model="dateFecha_nacido"
                                                            no-title
                                                            scrollable
                                                            locale="es-es"
                                                            @input="menuFechaNacido = false"
                                                        >
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-select
                                                        v-model="tutorItem.sexo_id"
                                                        :items="SEXOS"
                                                        label="Sexo*"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        :rules="sexoFieldRules"
                                                        :error-messages="sexoFieldErrors"
                                                        @change="sexoFieldErrors = []"
                                                        append-outer-icon="add"
                                                        @click:append-outer="showSexoForm = true"
                                                    >
                                                    </v-select>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-select
                                                        v-model="tutorItem.escolaridad_id"
                                                        :items="ESCOLARIDADES"
                                                        label="Escolaridad"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        :error-messages="escolaridadesFieldErrors"
                                                        @change="escolaridadesFieldErrors = []"
                                                        append-outer-icon="add"
                                                        @click:append-outer="showEscolaridadForm = true"
                                                    >
                                                    </v-select>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-tab-item>
                                    <v-tab-item :key="2" :value="`tab-2`">
                                        <v-container fluid grid-list-xl>
                                            <v-layout align-center wrap>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="tutorItem.empresa"
                                                        label="Empresa"
                                                        :counter="255"
                                                        :error-messages="empresaFieldErrors"
                                                        @blur="empresaFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="tutorItem.ocupacion"
                                                        label="Ocupación"
                                                        :counter="255"
                                                        :error-messages="ocupacionFieldErrors"
                                                        @blur="ocupacionErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="tutorItem.movil"
                                                        label="Móvil"
                                                        mask="phone"
                                                        :counter="10"
                                                        :error-messages="celularFieldErrors"
                                                        @blur="celularFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="tutorItem.telefono"
                                                        label="Teléfono"
                                                        mask="phone"
                                                        :counter="10"
                                                        :error-messages="telefonoFieldErrors"
                                                        @blur="telefonoFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="tutorItem.email"
                                                        label="Correo"
                                                        :counter="255"
                                                        :error-messages="emailFieldErrors"
                                                        @blur="emailFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <label for="file-upload" class="v-btn" style="cursor: pointer">
                                                        <v-icon class="pr-1">fa fa-cloud-upload</v-icon> Imagen
                                                    </label>
                                                    <input
                                                        ref="file"
                                                        id="file-upload"
                                                        type="file"
                                                        @change="onChangeFileUpload()"
                                                        accept="image/*"
                                                    />
                                                    <br />
                                                    <div class="error_message">
                                                        {{ fotoFileErrors[0] }}
                                                    </div>
                                                    {{
                                                        tutorItem.foto.length === 0
                                                            ? "Seleccione una imagen..."
                                                            : tutorItem.foto.name
                                                    }}
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-tab-item>
                                    <v-tab-item :key="3" :value="`tab-3`">
                                        <v-container fluid grid-list-xl>
                                            <v-layout align-center wrap>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="tutorItem.direccion"
                                                        label="Dirección"
                                                        :counter="255"
                                                        :error-messages="direccionFieldErrors"
                                                        @blur="direccionFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="tutorItem.colonia"
                                                        label="Colonia"
                                                        :counter="255"
                                                        @blur="coloniaFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="tutorItem.delegacion"
                                                        label="Delegación"
                                                        :counter="255"
                                                        :error-messages="delegacionFieldErrors"
                                                        @blur="delegacionFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="tutorItem.codigo_postal"
                                                        label="Codigo Postal"
                                                        :counter="10"
                                                        :error-messages="codigo_postalFieldErrors"
                                                        @blur="codigo_postalFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="tutorItem.telefono_casa"
                                                        label="Teléfono Casa"
                                                        mask="phone"
                                                        :counter="10"
                                                        :error-messages="telefono_casaFieldErrors"
                                                        @blur="telefono_casaFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="tutorItem.telefono_emergencia"
                                                        label="Teléfono Emergencia"
                                                        mask="phone"
                                                        :counter="10"
                                                        :error-messages="telefono_emergenciaFieldErrors"
                                                        @blur="telefono_emergenciaFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-tab-item>
                                </v-tabs-items>
                            </v-form>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <small class="ml-2">(*) indica campos requeridos</small>
                            <v-spacer></v-spacer>
                            <v-btn color="red" flat @click="cancelForm()" :disabled="loading">Cancelar</v-btn>
                            <v-btn
                                color="success"
                                flat
                                @click="saveForm()"
                                :disabled="disableSaveButton"
                                :loading="loading"
                                >Guardar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>
        <sexo-form
            v-if="showSexoForm"
            form-title="Nuevo sexo"
            :initial-item="null"
            @formCanceled="showSexoForm = false"
        >
        </sexo-form>
        <escolaridad-form
            v-if="showEscolaridadForm"
            form-title="Nueva escolaridad"
            :initial-item="null"
            @formCanceled="showEscolaridadForm = false"
        >
        </escolaridad-form>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import Util from "@/util"
const SexoForm = () => import("@/components/personal/nomencladores/sexo-form/sexo-form")
const EscolaridadForm = () => import("@/components/personal/nomencladores/escolaridad-form/escolaridad-form")

export default {
    components: {
        SexoForm,
        EscolaridadForm
    },
    props: {
        formTitle: { type: String, default: null },
        initialItem: { type: Object, default: null }
    },
    data() {
        return {
            activeTab: "tab-1",
            loading: false,
            validTutor: false,
            tutorItem: {
                cedula: "",
                nombre: "",
                apellido_paterno: "",
                apellido_materno: "",
                direccion: "",
                telefono: "",
                movil: "",
                foto: "",
                ocupacion: "",
                empresa: "",
                email: "",
                fecha_nacido: this.formatDate(new Date().toISOString().substr(0, 10)),
                escolaridad_id: "",
                sexo_id: "",
                colonia: "",
                delegacion: "",
                codigo_postal: "",
                telefono_casa: "",
                telefono_emergencia: ""
            },

            //menu fecha nacimiento
            menuFechaNacido: false,
            dateFecha_nacido: new Date().toISOString().substr(0, 10),

            //validaciones
            cedulaFieldRules: [
                v => !!v || "Debe proporcionar la cédula",
                v => v.length <= 20 || "La cédula solo puede contener 20 caracteres"
            ],
            cedulaFieldErrors: [],
            nombreFieldRules: [
                v => !!v || "Debe proporcionar un nombre",
                v => v.length <= 255 || "El nombre solo puede contener 255 caracteres"
            ],
            nombreFieldErrors: [],
            apellido_paternoFieldRules: [
                v => !!v || "Debe proporcionar el apellido paterno",
                v => v.length <= 255 || "El apellido paterno solo puede contener 255 caracteres"
            ],
            apellido_paternoFieldErrors: [],
            apellido_maternoFieldRules: [
                v => !!v || "Debe proporcionar el apellido materno",
                v => v.length <= 255 || "El apellido materno solo puede contener 255 caracteres"
            ],
            apellido_maternoFieldErrors: [],
            fecha_nacidoFieldRules: [v => !!v || "Debe proporcionar la fecha de nacimiento"],
            fecha_nacidoFieldErrors: [],
            sexoFieldRules: [v => !!v || "Debe proporcionar el sexo"],
            sexoFieldErrors: [],

            escolaridadesFieldErrors: [],
            ocupacionFieldErrors: [],
            empresaFieldErrors: [],
            celularFieldErrors: [],
            emailFieldErrors: [],
            telefonoFieldErrors: [],
            direccionFieldErrors: [],
            coloniaFieldErrors: [],
            delegacionFieldErrors: [],
            codigo_postalFieldErrors: [],
            telefono_casaFieldErrors: [],
            telefono_emergenciaFieldErrors: [],
            fotoFileErrors: [],

            //alert errores de validacion
            showErrorAlert: false,

            //nuevos nomencladores
            showSexoForm: false,
            showEscolaridadForm: false,

            //saber si se cargaron todos los datos necesarios para el formulario
            showErrorDataLoadedAlert: false
        }
    },
    computed: {
        ...mapGetters(["SEXOS", "ESCOLARIDADES"]),

        isNewRecord() {
            return this.initialItem === null
        },

        showForm: {
            get: function() {
                return true
            },
            set: function() {
                return this.cancelForm()
            }
        },

        disableSaveButton() {
            return this.loading || !this.validTutor || this.fotoFileErrors.length > 0
        },

        computedFechaNacidoFormatted() {
            return this.formatDate(this.dateFecha_nacido)
        }
    },

    methods: {
        saveForm() {
            this.loading = true
            this.$refs.tutorForm.validate()
            if (this.validTutor) {
                let tutor = new FormData()

                Object.entries(this.tutorItem).forEach(([key, value]) => {
                    tutor.append(key, value)
                })

                if (this.tutorItem.foto !== "") {
                    tutor.append("Tutor[file]", this.tutorItem.foto)
                }

                if (!this.isNewRecord) {
                    tutor.append("id", this.initialItem.id)
                }

                this.$store.dispatch(this.isNewRecord ? "ADD_TUTOR" : "UPDATE_TUTOR", tutor).then(result => {
                    if (!result) {
                        this.loading = false
                    }
                    if (result === null || result.status === 404 || result.status === 500) {
                        //cerrar el formulario si se inserto o actualizo bien (null) o cuando el elemento no existe o no hay coneccion con el servidor
                        this.$emit("formCanceled")
                    } else {
                        // El backend devolvió error de validación, pasando los errores a los campos correspondientes
                        let { data, status } = result
                        if (status === 422) {
                            this.showErrorAlert = true
                            data.forEach(error => {
                                switch (error.field) {
                                    case "cedula":
                                        this.cedulaFieldErrors.push(error.message)
                                        break
                                    case "nombre":
                                        this.nombreFieldErrors.push(error.message)
                                        break
                                    case "apellido_paterno":
                                        this.apellido_paternoFieldErrors.push(error.message)
                                        break
                                    case "apellido_materno":
                                        this.apellido_maternoFieldErrors.push(error.message)
                                        break
                                    case "fecha_nacido":
                                        this.fecha_nacidoFieldErrors.push(error.message)
                                        break
                                    case "sexo_id":
                                        this.sexoFieldErrors.push(error.message)
                                        break
                                    case "escolaridad_id":
                                        this.escolaridadesFieldErrors.push(error.message)
                                        break
                                    case "empresa":
                                        this.empresaFieldErrors.push(error.message)
                                        break
                                    case "ocupacion":
                                        this.ocupacionFieldErrors.push(error.message)
                                        break
                                    case "movil":
                                        this.celularFieldErrors.push(error.message)
                                        break
                                    case "telefono":
                                        this.telefonoFieldErrors.push(error.message)
                                        break
                                    case "email":
                                        this.emailFieldErrors.push(error.message)
                                        break
                                    case "direccion":
                                        this.direccionFieldErrors.push(error.message)
                                        break
                                    case "colonia":
                                        this.coloniaFieldErrors.push(error.message)
                                        break
                                    case "delegacion":
                                        this.delegacionFieldErrors.push(error.message)
                                        break
                                    case "codigo_postal":
                                        this.codigo_postalFieldErrors.push(error.message)
                                        break
                                    case "telefono_casa":
                                        this.telefono_casaFieldErrors.push(error.message)
                                        break
                                    case "telefono_emergencia":
                                        this.telefono_emergenciaFieldErrors.push(error.message)
                                        break
                                    default:
                                        console.log(error.message)
                                }
                            })
                        }
                    }
                    this.loading = false
                })
            } else {
                this.loading = false
            }
        },

        cancelForm() {
            this.$emit("formCanceled")
        },

        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split("-")
            return `${day}/${month}/${year}`
        },

        parseDate(date) {
            if (!date) return null

            const [day, month, year] = date.split("/")
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`
        },

        onChangeFileUpload() {
            this.tutorItem.foto = this.$refs.file.files[0]
            if (this.tutorItem.foto !== [] && Util.validateFile(this.tutorItem.foto.name, ["image"])) {
                this.fotoFileErrors = []
            } else {
                this.tutorItem.foto = []
                this.fotoFileErrors.push("El archivo seleccionado debe ser una imagen")
            }
        }
    },

    watch: {
        dateFecha_nacido: function() {
            this.tutorItem.fecha_nacido = this.formatDate(this.dateFecha_nacido)
        }
    },

    mounted() {
        this.$store.dispatch("LOAD_ALL_SEXOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_ESCOLARIDADES").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })

        if (this.initialItem !== null) {
            // Cargando información del elemento a actualizar
            this.tutorItem = Object.assign({}, this.initialItem)

            this.tutorItem.foto = ""

            if (!this.initialItem.escolaridad_id) {
                this.tutorItem.escolaridad_id = ""
            }

            if (this.initialItem.fecha_nacido) {
                let [dia, mes, ano] = this.initialItem.fecha_nacido.split("/")
                this.tutorItem.fecha_nacido = ano + "-" + mes + "-" + dia
                this.dateFecha_nacido = this.tutorItem.fecha_nacido
            }
        }
    }
}
</script>

<style scoped>
.v-alert {
    padding-top: 3px;
    padding-bottom: 4px;
    margin-top: 1px;
    margin-left: 2px;
    margin-right: 2px;
}

input[type="file"] {
    display: none;
}

.error_message {
    font-size: 12px;
    color: #ff5252;
    caret-color: #ff5252;
}
</style>
